import { Component, OnInit , ViewChild, Input, Output, EventEmitter} from '@angular/core';
import { InterfaceElement } from '../../model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { HTMLTree, TreeModel} from '../../model/html/html-elements/custom-html-elements/html-tree';

import { KEYS,ITreeOptions } from '@circlon/angular-tree-component';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';
import { InterfaceElementTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-type';

@Component({
  selector: 'app-html-tree',
  templateUrl: './html-tree.component.html',
  styleUrls: ['./html-tree.component.css']
})
export class HtmlTreeComponent implements OnInit {

  constructor(private uxControllerService: UXControllerService) { }

  @ViewChild('tree') tree;

  @Input() ie : InterfaceElement = new InterfaceElement();
  @Output() onNodeDrag: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectNode : EventEmitter<any> = new EventEmitter<any>();

  public ieTree: HTMLTree;

 // public treeModelData : TreeModel ;
  public treeModels:any;
  options: ITreeOptions = {
    displayField: 'name',
    isExpandedField: 'expanded',
    idField: 'id',
    hasChildrenField: 'nodes',
    actionMapping: {
      mouse: {
        click: (tree, node, $event) => {
          console.log('TreeNodeID: ' + node.data.id);
          this.uxControllerService.fetchIEUserAction(this.ie.Attributes.OnSelectUAID,
            this.ie,
            node.data.id,null,null,null,null,false);
        }
      },
      keys: {
        [KEYS.ENTER]: (tree, node, $event) => {
          node.expandAll();
        }
      }
    },
    nodeHeight: 30,
    allowDrag: (node) => {
      return true;
    },
    allowDrop: (node) => {
      return true;
    },
    allowDragoverStyling: true,
    levelPadding: 10,
    useVirtualScroll: true,
    animateExpand: false,
    scrollOnActivate: true,
    animateSpeed: 30,
    animateAcceleration: 1.2,
    scrollContainer: document.documentElement // HTML
  }


  generateListTreeData(table:InterfaceElement){

    let tree = new HTMLTree();
    let displayNameIndex : any;
    let nodeIDIndex: number;
    let orderNoIndex: number;
    let parentIDIndex: number;
    let treeIDIndex: number;

    let treeModelData = new TreeModel();
    let childTreeNode = new TreeModel();
    let treeModels = [];
    let parentOfTreeNode;

    displayNameIndex = table.EntityList.HeaderItems.map(function(d){return d['Name']}).indexOf(table.CustomizeOptions.Properties.DisplayName);
    nodeIDIndex = table.EntityList.HeaderItems.map(function(d){return d['Name']}).indexOf(table.CustomizeOptions.Properties.NodeID);
    orderNoIndex = table.EntityList.HeaderItems.map(function(d){return d['Name']}).indexOf(table.CustomizeOptions.Properties.OrderNo);
    parentIDIndex = table.EntityList.HeaderItems.map(function(d){return d['Name']}).indexOf(table.CustomizeOptions.Properties.ParentID);
    treeIDIndex = table.EntityList.HeaderItems.map(function(d){return d['Name']}).indexOf(table.CustomizeOptions.Properties.TreeID);
    let notFirst:number = 0;
    let rootTreeID:string = '';
    for(var row of table.EntityList.RowItems){
     
      if(row.ColItems[parentIDIndex].Value == null || row.ColItems[parentIDIndex].Value == ''){ //|| row.ColItems[parentIDIndex].Value == rootTreeID){
        treeModelData = {
          name: '', id: '', order: -1, children: [], treeId: '', rowId: ''
        };
        if (row.ColItems[displayNameIndex].Value != null && row.ColItems[displayNameIndex].Value != '')
          treeModelData.name = row.ColItems[displayNameIndex].Value;
        else 
          treeModelData.name = 'root';
        treeModelData.id = row.ColItems[nodeIDIndex].Value;
        treeModelData.order = row.ColItems[orderNoIndex].Value;
        treeModelData.treeId = row.ColItems[treeIDIndex].Value;
        treeModelData.rowId = row.ID;
        treeModels.push(treeModelData);
      }
      else {
        childTreeNode = {name: '', id: '',order: -1, treeId: '', parentId: '',rowId: ''};
        for(let tree of treeModels){
          if(tree.treeId == row.ColItems[treeIDIndex].Value){
            childTreeNode.name = row.ColItems[displayNameIndex].Value;
            childTreeNode.id = row.ColItems[nodeIDIndex].Value;
            childTreeNode.order = row.ColItems[orderNoIndex].Value;
            childTreeNode.treeId = row.ColItems[treeIDIndex].Value;
            childTreeNode.parentId = row.ColItems[parentIDIndex].Value;
            childTreeNode.rowId = row.ID;
             parentOfTreeNode = this.findParentForTreeData(tree, childTreeNode.parentId);
             this.setChildrenForTreeData(parentOfTreeNode, childTreeNode);
          }
        }
      }
    
    }

    tree.treeStructures = treeModels;
    return tree;

  }

  generateMenuItemTreeData(ie:InterfaceElement){
    let tree = new HTMLTree();     
    let treeModels = [];
     let treeModelData : TreeModel = {name: '', id: '',order: -1, children: [], treeId:'', parentId: '',rowId : '', clickUAID: ''};
 
     for(var m of ie.MenuItems){
      
       if(m.Attributes.ParentID == null || m.Attributes.ParentID == ''){
         /*treeModelData = {
             settings: {
                'rightMenu': false,
             },
             value: '', id: '',order: -1, children: [], treeId: '', clickUAID: ''
         };*/
         treeModelData.name = m.DisplayName;
         treeModelData.order = m.Attributes.OrderNo;
         treeModelData.treeId = m.Attributes.TreeGroupID;
         treeModelData.id = m.Attributes.TreeID;
         treeModelData.clickUAID = m.Attributes.OnClickUAID;
         treeModels.push(treeModelData);
       }
       else {
       
        let childTreeNode : TreeModel = {name: '', id: '',order: -1, children: [], treeId:'', parentId: '',rowId : '', clickUAID: ''};
         for(let tree of treeModels){
            if(tree.treeId == m.Attributes.TreeGroupID){
              childTreeNode.name = m.DisplayName;
              childTreeNode.id = m.Attributes.TreeID;
              childTreeNode.order = m.Attributes.OrderNo;
              childTreeNode.treeId = m.Attributes.TreeGroupID;
              childTreeNode.parentId = m.Attributes.ParentID;
              childTreeNode.clickUAID = m.Attributes.OnClickUAID;
              let parentOfTreeNode = this.findParentForTreeData(tree, childTreeNode.parentId);
              this.setChildrenForTreeData(parentOfTreeNode, childTreeNode);
            }
         }
       }
 
     }
     tree.treeStructures = treeModels;
     return tree;
   }

  findParentForTreeData(o, id) {
    if( o.id === id ){
      return o;
    }
    var result, p;
    for (p in o) {
        if( o.hasOwnProperty(p) && typeof o[p] === 'object' ) {
            result = this.findParentForTreeData(o[p], id);
            if(result){
                return result;
            }
        }
    }
    return result;
  }

  setChildrenForTreeData(obj, childobj){
    if(obj['id'] === childobj['parentId']){
      if(obj.hasOwnProperty('children')){
        obj.children.push(childobj);
      }else {
        obj['children'] = [];
        obj.children.push(childobj);

      }
      obj.children.sort((a,b) => a.order - b.order);
    }
  }

  ngOnInit() {
    if(this.ie != null){
      if(this.ie.TypeDID == InterfaceElementTypes.EntityList){
        this.ieTree =  this.generateListTreeData(this.ie);
        this.treeModels = this.ieTree.treeStructures;
      }
      if(this.ie.TypeDID == InterfaceElementTypes.MenuList){
        this.ieTree = this.generateMenuItemTreeData(this.ie);
        this.treeModels = this.ieTree.treeStructures;
      }
    }
  }


  

  ngAfterViewInit() {
    this.tree.treeModel.expandAll();
    setTimeout(() => {
      if(this.ie.Values.length>0){
        if (this.ie.Values[0].Value != null) this.tree.treeModel.getNodeById(this.ie.Values[0].Value).setIsActive(true);
      }
    }, 100);
  }

}
